import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Spin } from "antd";

import { SelectorInfoPopover } from "../../";

const Selector = ({ style, items, onClick }) => {
  return (
    <div style={style} className={"test-selector"}>
      {items ? (
        items.map(i => (
          <div key={i.value}>
            <Checkbox
              onChange={onClick(i.value)}
              disabled={i.disabled}
              defaultChecked={i.isChecked}
            >
              {i.text}
              {i.description && (
                <SelectorInfoPopover text={`${i.description} (${i.units})`} />
              )}
            </Checkbox>
          </div>
        ))
      ) : (
        <Spin />
      )}
    </div>
  );
};

Selector.propTypes = {
  style: PropTypes.object,
  items: PropTypes.array.isRequired
};

export default Selector;



// WEBPACK FOOTER //
// ./src/views/components/selector_list/selector/Selector.jsx